import { gql } from '@apollo/client';

export const ASSIGN_SEAT = gql`
  mutation AssignSeat($input: AssignSeatInput!) {
    assignSeat(input: $input) {
      id
      seatNumber
      tripId
      playerId
      player {
        id
        firstName
        lastName
        profile {
          pictureThumbnail
        }
      }
    }
  }
`;

export const UNASSIGN_SEAT = gql`
  mutation UnassignSeat($id: Int!) {
    unassignSeat(id: $id) {
      id
    }
  }
`;

export const UPDATE_SEAT_ASSIGNMENT = gql`
  mutation UpdateSeatAssignment($id: Int!, $seatNumber: Int!) {
    updateSeatAssignment(id: $id, seatNumber: $seatNumber) {
      id
      seatNumber
      tripId
      playerId
    }
  }
`;

export const BULK_ASSIGN_SEATS = gql`
  mutation BulkAssignSeats($input: BulkAssignSeatsInput!) {
    bulkAssignSeats(input: $input) {
      id
      seatNumber
      tripId
      playerId
      player {
        id
        firstName
        lastName
        profile {
          pictureThumbnail
        }
      }
    }
  }
`;

export const CLEAR_SEAT_ASSIGNMENTS = gql`
  mutation ClearSeatAssignments($tripId: Int!) {
    clearSeatAssignments(tripId: $tripId)
  }
`;

export const MARK_CAUTION_PAID = gql`
  mutation MarkCautionPaid($seatAssignmentId: Int!) {
    markCautionPaid(seatAssignmentId: $seatAssignmentId) {
      id
      cautionPaid
      cautionReturned
    }
  }
`;

export const MARK_CAUTION_RETURNED = gql`
  mutation MarkCautionReturned($seatAssignmentId: Int!) {
    markCautionReturned(seatAssignmentId: $seatAssignmentId) {
      id
      cautionPaid
      cautionReturned
    }
  }
`;

export const RESET_CAUTION = gql`
  mutation ResetCaution($seatAssignmentId: Int!) {
    resetCaution(seatAssignmentId: $seatAssignmentId) {
      id
      cautionPaid
      cautionReturned
    }
  }
`;
